import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useTableContext } from '../../Table.Context/index.es.js';
import { useTableBodyRowContext } from '../Table.Body.Row/Table.Body.Row.Context/index.es.js';

const TableBodyCell = ({ className, children, ...rest })=>{
    const [{ density, groupHeaderVariant }] = useTableContext();
    const { isGroupHeader } = useTableBodyRowContext();
    return jsx("td", {
        className: classNames('cb-table-body-cell', {
            'group-header-cell': isGroupHeader
        }, {
            [`group-header-cell-${groupHeaderVariant}`]: isGroupHeader
        }, className, density),
        ...rest,
        children: children
    });
};
TableBodyCell.displayName = 'Table.Body.Cell';

export { TableBodyCell };
//# sourceMappingURL=Table.Body.Cell.es.js.map
